import { startQuasarApp } from '@ligo/shared/quasar';
import { bootFiles } from './boot';
import store from './store';
import router from './router';
import App from './App.vue';
import '@splidejs/splide/dist/css/splide.min.css';
import './css/quasar.sass';

startQuasarApp(App, bootFiles, { store, router });
